import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Markets } from "@/components/site/Markets";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Payment } from "@/components/site/Payment";
import { scrollToId } from "@/lib/lenis";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Services />
      <Markets />
      <About />
      <Payment />
      <Contact />
    </main>
  );
}
